import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import ViewContainerDecorator from 'documents-lib/js/decorators/ViewContainerDecorator';
import ViewContainer from 'documents-lib/js/containers/ViewContainer';
import { FloatingAlertList } from 'foundations-components/transitional/components/FloatingAlertList';
import * as DocumentsPublicActions from '../actions/DocumentsPublicActions';
import * as PublicViewerActions from '../actions/PublicViewerActions';
import { isChirpEnabled } from 'documents-lib/js/utils/isChirpEnabled';
import { useRequiresViewerInfo, useRequiresViewerInfoCHIRP } from '../hooks/useRequiresViewerInfo';
import setDocumentTitle from 'I18n/utils/setDocumentTitle';
import { useFavicon } from '../hooks/useFavicon';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ViewComponent = ViewContainerDecorator(ViewContainer, {
  isPreview: false,
  documentActions: DocumentsPublicActions,
  hasHigherDocumentsLimit: undefined,
  publicViewerActions: PublicViewerActions
});
const getMatch = () => {
  var _searchParams$get;
  let presentationId = 0;
  const matchResult = window.location.pathname.match(/\/documents\/\d+\/view\/(\d+)/);
  if (matchResult) {
    const [__string, _presentationId] = matchResult;
    presentationId = Number(_presentationId);
  }
  const searchParams = new URLSearchParams(window.location.search);
  const accessId = (_searchParams$get = searchParams.get('accessId')) !== null && _searchParams$get !== void 0 ? _searchParams$get : undefined;

  // Mimic how Router sets up params
  return {
    params: {
      presentationId,
      accessId
    }
  };
};
export const ViewApplication = () => {
  var _presentation$sharedL, _presentation$present;
  const match = useMemo(() => getMatch(), []);
  const requiresViewerInfoREST = useRequiresViewerInfo();
  const requiresViewerInfoCHIRP = useRequiresViewerInfoCHIRP();
  const isUngatedToChirp = isChirpEnabled();
  const requiresViewerInfo = isUngatedToChirp ? requiresViewerInfoCHIRP : requiresViewerInfoREST;
  const presentation = useSelector(state => state.view.presentation);
  const faviconUrl = isUngatedToChirp ? (_presentation$sharedL = presentation.sharedLink) === null || _presentation$sharedL === void 0 || (_presentation$sharedL = _presentation$sharedL.brandingMetadata) === null || _presentation$sharedL === void 0 ? void 0 : _presentation$sharedL.logoUrl : (_presentation$present = presentation.presentation) === null || _presentation$present === void 0 || (_presentation$present = _presentation$present.brandingMetadata) === null || _presentation$present === void 0 ? void 0 : _presentation$present.logoUrl;
  useFavicon({
    faviconUrl
  });
  useEffect(() => {
    var _presentation$sharedL2, _presentation$present2;
    if ((_presentation$sharedL2 = presentation.sharedLink) !== null && _presentation$sharedL2 !== void 0 && _presentation$sharedL2.name) {
      document.title = presentation.sharedLink.name;
    } else if ((_presentation$present2 = presentation.presentation) !== null && _presentation$present2 !== void 0 && _presentation$present2.name) {
      document.title = presentation.presentation.name;
    } else if (presentation.presentation === undefined || presentation.sharedLink === undefined) {
      setDocumentTitle('app.htmlTitle');
    }
  }, [presentation]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ViewComponent, {
      match: match,
      requiresViewerInfo: requiresViewerInfo
    }), /*#__PURE__*/_jsx(FloatingAlertList, {})]
  });
};